export default __webpack_public_path__ + "static/media/Amazon_scam.bc4a94c0.mp3";